import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceToIrbValidationQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_gen_doc_to_irb_validation_queue_container.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, ApiVisa } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class ToIrbValidationQueueService extends BaseApiTemplateService<MyEInvoiceToIrbValidationQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/validation-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/validation-queues/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/validation-queues/backoffice-ep';
    this.httpClient = http;
  }

  processValidationQueue(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/validation-queues/process-validation-queue/backoffice-ep';
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/validation-queues/process-validation-queue/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}